







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FeeBudgetList from '@/components/fee-budgets/fee-budget-list.vue';

@Component({
  components: {
    FeeBudgetList,
    PageTitle
  }
})
export default class FeeBudgets extends Vue {}
